module.exports = __webpack_public_path__ + "static/media/Distrito-02.e9d2d0ea.png";